export default __webpack_public_path__ + "static/media/tempIcon.47520696.svg";